import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { Mdlusu } from "../modelos/mdlusu";
import {
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";

export interface MenuItem {
  nombre: string;
  ruta: string;
  //icono: any;
}

@Injectable({
  providedIn: "root",
})
export class CentralService {
  public datosIden = new Mdlusu("", "", "", "");

  //public UrlCave: string = "http://localhost:3010";
  public UrlCave: string = "";

  // Opciones del menú
  public listaMnu = [
    { nombre: "Cambiar contraseña", ruta: "/mdfclave", ico: 0 },
    //{ nombre: 'Ficha de Capital', ruta: '/fichacap', ico: 1 },
    { nombre: "Entregas Corderos", ruta: "/entregaOpcion", ico: 2 },
    { nombre: "Entregas Piensos", ruta: "/piensoOpcion", ico: 2 },
    { nombre: "Anticipos", ruta: "/anticipo", ico: 3 },
    { nombre: "Liquidaciones", ruta: "/liquida", ico: 4 },
    { nombre: "Facturas", ruta: "/factura", ico: 5 },
  ];

  public iconos = [
    faKey,
    faEuroSign,
    faTractor,
    faMoneyBill,
    faFileInvoice,
    faFileAlt,
  ];

  // Selector de fechas
  public gnPriDia: Date;
  public gnUltDia: Date;

  // Ficha de Capital
  public FicModoLis = 0;
  public FicFormLis = 0;

  // Entregas
  public EntModoLis = 0;
  public EntFormLis = 0;

  // Piensos (Nuevo)
  public PnsModoLis = 0;
  public PnsFormLis = 0;

  // Excesos
  public ExcTinta = 0;
  public ExcBlanc = 0;

  constructor(private http: HttpClient) {}

  private menuSubject = new BehaviorSubject<MenuItem[]>([]);
  menu$ = this.menuSubject.asObservable();
  getMenuItems(): MenuItem[] {
    if (!this.datosIden || !this.datosIden.UsuUsu) {
      return [];
    }

    return this.listaMnu.map((item) => ({
      nombre: item.nombre,
      ruta: item.ruta,
      //icono: item.ico,
    }));
  }

  updateMenu() {
    if (!this.datosIden || !this.datosIden.UsuUsu) {
      this.menuSubject.next([]);
      return;
    }

    const items = this.listaMnu.map((item) => ({
      nombre: item.nombre,
      ruta: item.ruta,
      //icono: item.ico,
    }));

    this.menuSubject.next(items);
  }

  // central.service.ts

  getModoLis(): { SwResum: boolean; SwDetal: boolean; SwTotal: boolean } {
    const modo = this.FicModoLis;
    return {
      SwResum: modo === 0,
      SwDetal: modo === 1,
      SwTotal: modo === 2,
    };
  }

  getFormLis(): { SwLista: boolean; SwImpre: boolean; SwExcel: boolean } {
    const form = this.FicFormLis;
    return {
      SwLista: form === 0,
      SwImpre: form === 1,
      SwExcel: form === 2,
    };
  }
  public ponIden(datos: any) {
    this.datosIden.UsuUsu = datos[0].UsuUsu;
    this.datosIden.UsuNom = datos[0].UsuNom;
    this.datosIden.UsuClv = datos[0].UsuClv;
    this.datosIden.UsuToken = datos[0].UsuToken;

    this.gnPriDia = this.cadenaFecha(datos[0].UsuPrF);
    this.gnUltDia = this.cadenaFecha(datos[0].UsuUlF);

    this.ExcTinta = datos[0].UsuTin;
    this.ExcBlanc = datos[0].UsuBla;
  }

  public borraIden() {
    this.datosIden.UsuUsu = "";
    this.datosIden.UsuNom = "";
    this.datosIden.UsuClv = "";
    this.datosIden.UsuToken = "";
    this.ExcTinta = 0;
    this.ExcBlanc = 0;
  }

  /* *************************************** */
  /*          Gestión del HTTP               */
  /* *************************************** */
  cambiaClave(nueClave: string): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const vnue = this.mete(nueClave);
    const identi = vusu + "|" + vclv;
    const vfiltro = { filtro: identi, datos: vnue };
    return this.http.post<any>(this.UrlCave + "/cavemdfclv", vfiltro, {
      responseType: "json",
    });
  }

  fichaCapital(modo: number, tipo: number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + modo + "|" + tipo;
    return this.http.get<any>(this.UrlCave + "/caveficcap/?filtro=" + filtro);
  }

  entregacord(modo: number, lineas: any[]): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);

    const filtro = vusu + "|" + vclv + "|" + modo;

    const body = {
      filtro: filtro,
      datos: lineas,
    };
    return this.http.post<any>(this.UrlCave + "/alancrudhistcordero", body);
  }

  listClientes(): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv;
    return this.http.get<any>(
      this.UrlCave + "/alanlstclientes/?filtro=" + filtro,
    );
  }

  listarPiensos(
    priFech: string,
    ultFech: string,
    orden: number,
    socio?: number,
  ): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);

    const socioStr = socio && socio !== 0 ? socio.toString() : "";

    const filtro =
      vusu +
      "|" +
      vclv +
      "|" +
      socioStr +
      "|" +
      priFech +
      "|" +
      ultFech +
      "|" +
      orden;
    return this.http.get<any>(
      this.UrlCave + "/alanlistpienso/?filtro=" + filtro,
    );
  }

  listarCorderos(
    priFech: string,
    ultFech: string,
    socio?: number,
  ): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);

    const socioStr = socio ? socio.toString() : "";

    const filtro =
      vusu +
      "|" +
      vclv +
      "|" +
      priFech +
      "|" +
      ultFech +
      "|" +
      1 +
      "|" +
      socioStr;
    // console.log("listarCorderos.filtro", filtro);
    return this.http.get<any>(
      this.UrlCave + "/alanlistcordero/?filtro=" + filtro,
    );
  }

  entregaPiensos(modo: number, lineas: any[]): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);

    const filtro = vusu + "|" + vclv + "|" + modo;

    const body = {
      filtro: filtro,
      datos: lineas,
    };

    return this.http.post<any>(this.UrlCave + "/alancrudhistpienso", body);
  }

  crudPiensos(datos: any[], modo: number): Observable<any> {
    // console.log("crudPiensos", datos, modo);
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + modo;

    datos.forEach((r) => {
      r.ttcodmar = r.ttcodmar || 0;
      let tx = r.ttdesmar;
      r.ttdesmar = tx;
      r.ttcodtip = r.ttcodtip || 0;
      tx = r.ttdestip;
      r.ttdestip = tx;
    });
    const vFiltro = { filtro: filtro, datos: datos };

    return this.http.post<any>(this.UrlCave + "/alancrudpienso", vFiltro, {
      responseType: "json",
    });
  }

  consulPiensos(marca: string | number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + marca;
    return this.http.get<any>(
      this.UrlCave + "/alangespienso/?filtro=" + filtro,
    );
  }

  consulFinca(socio: string): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + socio;
    return this.http.get<any>(
      this.UrlCave + "/alanexplotacion/?filtro=" + filtro,
    );
  }

  consulAnticipo(modo: number, pfec: string, ufec: string): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + modo + "|" + pfec + "|" + ufec;
    return this.http.get<any>(this.UrlCave + "/caveanticipo/?filtro=" + filtro);
  }

  documAnticipo(ejer: number, numant: number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + ejer + "|" + numant;
    return this.http.get<any>(this.UrlCave + "/cavedocanti/?filtro=" + filtro);
  }

  consulLiquida(modo: number, pfec: string, ufec: string): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + modo + "|" + pfec + "|" + ufec;
    // console.log(filtro);
    return this.http.get<any>(this.UrlCave + "/caveliquida/?filtro=" + filtro);
  }

  documLiquida(ejer: number, numliq: number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + ejer + "|" + numliq;
    return this.http.get<any>(this.UrlCave + "/cavedocliqui/?filtro=" + filtro);
  }

  consulFactura(tipo: number, pfec: string, ufec: string): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro = vusu + "|" + vclv + "|" + tipo + "|" + pfec + "|" + ufec;
    return this.http.get<any>(this.UrlCave + "/cavefactu/?filtro=" + filtro);
  }

  documFactura(ejer: number, serifac: string, numfac: number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    const filtro =
      vusu + "|" + vclv + "|" + ejer + "|" + serifac + "|" + numfac;
    return this.http.get<any>(this.UrlCave + "/cavedocfactu/?filtro=" + filtro);
  }

  pdfLiquidacion(ejer: number, numliq: number): Observable<any> {
    const vusu = this.mete(this.datosIden.UsuUsu);
    const vclv = this.mete(this.datosIden.UsuClv);
    return this.http.post<any>(this.UrlCave + "/getImpresionLiquidacion", {
      LiqNumer: numliq,
      Eje_activo: ejer,
      Emp_activo: "1",
      iFiltro: vusu + "|" + vclv,
    });
  }

  /* *************************************** */
  /*           Funciones especiales          */
  /* *************************************** */
  public mete(cadena): string {
    const clv = this.ale(2, 4);
    let tx = "";
    let zx = "";
    let sl = "";
    let i = 0;
    let k = 0;
    let n = 0;
    tx = "";
    n = cadena.length;
    if (n === 0) {
      return "";
    }
    for (i = n; i >= 0; i--) {
      tx = tx + cadena.charAt(i);
    }
    sl = "";
    for (i = 0; i < tx.length; i++) {
      zx = "";
      for (k = 0; k < clv; k++) {
        n = this.ale(122, 48);
        zx = zx + String.fromCharCode(n);
      }
      sl = sl + tx.charAt(i) + zx;
    }
    for (k = 0; k < clv; k++) {
      n = this.ale(122, 48);
      i = this.ale(122, 48);
      sl = String.fromCharCode(n) + sl + String.fromCharCode(i);
    }
    sl = String.fromCharCode(clv + 64) + sl;
    return sl;
  }

  public saca(entra): string {
    let tx = "";
    let zx = "";
    let i = 0;
    let n = 0;
    if (entra.length === 0) {
      return "";
    }
    tx = entra.substring(0, 1);
    const clv = tx.charCodeAt(0) - 64;
    entra = entra.slice(clv + 1);
    tx = "";
    n = clv + 1;
    for (i = 0; i < entra.length; i += n) {
      tx = tx + entra.charAt(i);
    }
    n = tx.length - 1;
    if (n > 0) {
      tx = tx.substring(0, n);
    }

    zx = "";
    n = tx.length;
    for (i = n; i >= 0; i--) {
      zx = zx + tx.charAt(i);
    }
    return zx;
  }

  public ale(n1, n2) {
    const k = n2 - n1;
    let s = Math.floor(Math.random() * k + n1);
    if (s >= 58 && s <= 54) {
      s = s + 7;
    }
    if (s >= 91 && s <= 96) {
      s = s + 6;
    }
    return s;
  }

  public ponAhora(): string {
    const hoy = new Date();
    let dia = "";
    let mes = "";
    let nan = "";
    let hor = "";
    let min = "";
    let seg = "";
    let n = hoy.getDate();
    if (n < 10) {
      dia = "0" + n.toString();
    } else {
      dia = n.toString();
    }
    n = hoy.getMonth() + 1;
    if (n < 10) {
      mes = "0" + n.toString();
    } else {
      mes = n.toString();
    }
    n = hoy.getFullYear();
    if (n < 10) {
      nan = "0" + n.toString();
    } else {
      nan = n.toString();
    }
    n = hoy.getHours();
    if (n < 10) {
      hor = "0" + n.toString();
    } else {
      hor = n.toString();
    }
    n = hoy.getMinutes();
    if (n < 10) {
      min = "0" + n.toString();
    } else {
      min = n.toString();
    }
    n = hoy.getSeconds();
    if (n < 10) {
      seg = "0" + n.toString();
    } else {
      seg = n.toString();
    }
    const salida =
      dia + "/" + mes + "/" + nan + "  " + hor + ":" + min + ":" + seg;
    return salida;
  }

  public fechaCadena(pfec: Date): string {
    if (!pfec) return "";

    let y = pfec.getMonth() + 1;
    let nmes = "";
    let ndia = "";
    if (y < 10) {
      nmes = "0" + y.toString();
    } else {
      nmes = y.toString();
    }
    y = pfec.getDate();
    if (y < 10) {
      ndia = "0" + y.toString();
    } else {
      ndia = y.toString();
    }
    const sfe = ndia + "-" + nmes + "-" + pfec.getFullYear();
    // const sfes = pfec.getFullYear() + '-' + nmes + '-' + ndia;
    return sfe;
  }
  public cadenaFecha(fe: string): Date {
    let tb = ["1", "1", "2000"];
    if (fe.indexOf("/") > -1) {
      tb = fe.split("/");
    }
    if (fe.indexOf("-") > -1) {
      tb = fe.split("-");
    }
    const dd = parseInt(tb[0], 10);
    const mm = parseInt(tb[1], 10) - 1;
    const aa = parseInt(tb[2], 10);
    const dfe = new Date(aa, mm, dd);
    return dfe;
  }

  public converiso(cadena): string {
    cadena = cadena.replace(/á/g, "||a");
    cadena = cadena.replace(/é/g, "||e");
    cadena = cadena.replace(/í/g, "||i");
    cadena = cadena.replace(/ó/g, "||o");
    cadena = cadena.replace(/ú/g, "||u");
    cadena = cadena.replace(/ñ/g, "||n");
    cadena = cadena.replace(/ç/g, "||c");

    cadena = cadena.replace(/Á/g, "||A");
    cadena = cadena.replace(/É/g, "||E");
    cadena = cadena.replace(/Í/g, "||I");
    cadena = cadena.replace(/Ó/g, "||O");
    cadena = cadena.replace(/Ú/g, "||U");
    cadena = cadena.replace(/Ñ/g, "||N");
    cadena = cadena.replace(/Ç/g, "||C");

    cadena = cadena.replace(/à/g, "|#a");
    cadena = cadena.replace(/è/g, "|#e");
    cadena = cadena.replace(/ì/g, "|#i");
    cadena = cadena.replace(/ò/g, "|#o");
    cadena = cadena.replace(/ù/g, "|#u");
    cadena = cadena.replace(/À/g, "|#A");
    cadena = cadena.replace(/È/g, "|#E");
    cadena = cadena.replace(/Ì/g, "|#I");
    cadena = cadena.replace(/Ò/g, "|#O");
    cadena = cadena.replace(/Ù/g, "|#U");

    cadena = cadena.replace(/â/g, "|$a");
    cadena = cadena.replace(/ê/g, "|$e");
    cadena = cadena.replace(/î/g, "|$i");
    cadena = cadena.replace(/ô/g, "|$o");
    cadena = cadena.replace(/û/g, "|$u");
    cadena = cadena.replace(/Â/g, "|$A");
    cadena = cadena.replace(/Ê/g, "|$E");
    cadena = cadena.replace(/Î/g, "|$I");
    cadena = cadena.replace(/Ô/g, "|$O");
    cadena = cadena.replace(/Û/g, "|$U");

    cadena = cadena.replace(/ä/g, "|&a");
    cadena = cadena.replace(/ë/g, "|&e");
    cadena = cadena.replace(/ï/g, "|&i");
    cadena = cadena.replace(/ö/g, "|&o");
    cadena = cadena.replace(/ü/g, "|&u");
    cadena = cadena.replace(/Ä/g, "|&A");
    cadena = cadena.replace(/Ë/g, "|&E");
    cadena = cadena.replace(/Ï/g, "|&I");
    cadena = cadena.replace(/Ö/g, "|&O");
    cadena = cadena.replace(/Ü/g, "|&U");

    let salida = cadena;
    for (let i = 0; i < cadena.length; i++) {
      const k = cadena.charCodeAt(i);
      const x = cadena.charAt(i);
      if (k < 32 || k > 125) {
        salida = salida.replace(x, "_");
      }
    }

    return salida;
  }
}
